import { render, staticRenderFns } from "./ChatChangeQuote.vue?vue&type=template&id=116a35aa&scoped=true&"
import script from "./ChatChangeQuote.vue?vue&type=script&lang=js&"
export * from "./ChatChangeQuote.vue?vue&type=script&lang=js&"
import style0 from "./ChatChangeQuote.vue?vue&type=style&index=0&id=116a35aa&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "116a35aa",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
installComponents(component, {VBtn})
